import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from '../../Form/Label';
import Text from '../../Global/Text';
import { stepShowHide } from '../../../utilities/form/formUtils';

export const Notification = ({
  message,
  className,
  hidden,
  label,
  setValues,
  values,
  setFormValues,
  dispatch,
  userData,
  setFieldValue,
  initialValues,
  notificationType,
}) => {
  if (hidden) {
    return <div/>;
  }

  const formFieldClass = classNames(
    'form__field',
    className
  );
  
  const labelParams = {
    setValues,
    values,
    setFormValues,
    dispatch,
    userData,
    setFieldValue,
    initialValues,
    ...label,
  };

  const labelHidden = label ? stepShowHide(label.hidden, label.showHide, userData) : false;

  return (
    <div className={formFieldClass}>
      <anchor-notification-inline type={notificationType} style={{"--notification-inline-width": "100%"}}> 
        <Text value={message}/> 
        {label && !labelHidden &&
          <Label {...labelParams} />
        }
      </anchor-notification-inline>
    </div>
  );
};

Notification.defaultProps = {
  className: '',
  label: null,
};

Notification.propTypes = {
  message: PropTypes.string.isRequired,
  notificationType: PropTypes.string,
  className: PropTypes.string,
  hidden: PropTypes.bool.isRequired,
  label: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  setFormValues: PropTypes.func,
  setValues: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};
